"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_router_1 = require("fluxible-router");
class TagsWidgetProps {
}
class TagsWidget extends React.Component {
    render() {
        let i = 0;
        return (React.createElement("div", { className: 'widget widget_tag_cloud' },
            React.createElement("h4", null, "Tag cloud"),
            React.createElement("div", { className: 'tagcloud' }, this.props.data.queryData.map((tag) => {
                i++;
                return (React.createElement(fluxible_router_1.NavLink, { key: i, preserveScrollPosition: true, href: '/blog?tag=' + tag }, tag));
            }))));
    }
}
exports.default = TagsWidget;
